import { Injectable } from "@angular/core";

import { from, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ToastifyService } from "../../shared/toastify-service";
import { activateLegendData, activateLegendFailure, activateLegendSuccess, addLegendData, addLegendFailure, addLegendSuccess, deactivateLegendData, deactivateLegendFailure, deactivateLegendSuccess, editLegendData, editLegendFailure, editLegendSuccess, fetchLegendsListingData, fetchLegendsListingFailure, fetchLegendsListingSuccess } from "./legend.actions";
import { DesignLegend } from "../../core/models/designlegends.models";
import { LegendService } from "../../core/services/legend.service";

@Injectable()
export class LegendEffects {

    // FETCH PLACARDS
    fetchLegendsListingData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchLegendsListingData),
            mergeMap(({ postdata }) =>
                this.legendService.getAllLegends(postdata).pipe(
                    map((designlegends) => fetchLegendsListingSuccess({ designlegends: designlegends })),
                    catchError((error) => of(fetchLegendsListingFailure({ error })))
                )
            ),
        ),
    );

    fetchLegendsListingFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchLegendsListingFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // ADD PLACARD RECORD
    addLegendData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addLegendData),
            mergeMap(({ postdata }) =>
                this.legendService.createLegend(postdata).pipe(
                    map((legend: any) => addLegendSuccess({ designlegend: legend })),
                    catchError(error => of(addLegendFailure({ error })))
                )
            )
        )
    );

    addLegendSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addLegendSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Legend added successfully");
                })
            ),
        { dispatch: false }
    );

    addLegendFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addLegendFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // ADD PLACARD RECORD
    editLegendData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(editLegendData),
            mergeMap(({ postdata, id}) =>
                this.legendService.updateLegend(postdata, id).pipe(
                    map((legend: any) => editLegendSuccess({ designlegend: legend })),
                    catchError(error => of(editLegendFailure({ error })))
                )
            )
        )
    );

    editLegendSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editLegendSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Legend updated successfully");
                })
            ),
        { dispatch: false }
    );

    editLegendFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editLegendFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    activateLegendData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(activateLegendData),
            mergeMap(({ postdata, id }) =>
                this.legendService.updateLegend(postdata, id).pipe(
                    map((legend: any) => activateLegendSuccess({ designlegend: legend })),
                    catchError(error => of(activateLegendFailure({ error })))
                )
            )
        )
    );

    activateLegendSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(activateLegendSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Legend activated");
                })
            ),
        { dispatch: false }
    );



    deactivateLegendData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deactivateLegendData),
            mergeMap(({ postdata, id }) =>
                this.legendService.updateLegend(postdata, id).pipe(
                    map((legend: any) => deactivateLegendSuccess({ designlegend: legend })),
                    catchError(error => of(deactivateLegendFailure({ error })))
                )
            )
        )
    );

    deactivateLegendSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(deactivateLegendSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Legend deactivated");
                })
            ),
        { dispatch: false }
    );



    constructor(
        private actions$: Actions,
        private toastifyService: ToastifyService,
        private legendService: LegendService
    ) {
    }
}